import { FieldValues, Path, useFormContext } from "react-hook-form";
import { SxProps } from "@mui/material";
import { SelectInput } from "./SelectInput";
import { CreateDrivingLessonFormValues } from "../dialogs/AddAppointmentDialog/CreateDrivingLessonForm";
import { CreateSimulatorDrivingLessonFormValues } from "../dialogs/AddAppointmentDialog/CreateSimulatorDrivingLessonForm";
import { EditDrivingLessonFormValues } from "../dialogs/EventDialog/EditDrivingLessonForm";
import { useEffect, useMemo, useRef } from "react";

export const DrivingLessonDurationInput = (props: {
  source: Path<FieldValues>;
  options: Array<number>;
  unitLabel?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  sx?: SxProps;
}) => {
  const unitLabel = props.unitLabel ?? "Minuten";
  const options = useMemo(
    () => props.options.map((it) => [it, `${it} ${unitLabel}`] as [number, string]),
    [props.options, unitLabel],
  );
  const { watch, setValue } = useFormContext<
    CreateDrivingLessonFormValues | CreateSimulatorDrivingLessonFormValues | EditDrivingLessonFormValues
  >();
  const drivingLessonType = watch("drivingLessonType");
  const durationInMinutes = watch("durationInMinutes");
  const prefDrivingLessonTypeRef = useRef(drivingLessonType);
  const durationInMinutesBackupRef = useRef(durationInMinutes);
  useEffect(() => {
    if (drivingLessonType !== prefDrivingLessonTypeRef.current) {
      // Driving lesson type changed ...
      prefDrivingLessonTypeRef.current = drivingLessonType;
      if (drivingLessonType === "schaltkompetenz") {
        // Backup current duration ...
        durationInMinutesBackupRef.current = durationInMinutes;
        // and set duration to 15 minutes ...
        setValue("durationInMinutes", 15);
      } else if (durationInMinutes === 15) {
        // Restore backed up duration ...
        setValue("durationInMinutes", durationInMinutesBackupRef.current);
      }
    }
  }, [drivingLessonType, durationInMinutes]);
  return (
    <SelectInput
      source={props.source}
      label="Dauer"
      size={props.size}
      options={options}
      fullWidth={props.fullWidth}
      sx={props.sx}
    />
  );
};
